module.exports = __webpack_public_path__ + "static/media/CharliePicture.52edee64.png";